import { createReducer } from '@reduxjs/toolkit'
import { HomeFeedResolvedSection } from '@/services/api'
import { setHomeFeedSections, setHomeFeedStatus } from './action'

export interface HomeFeedState {
  sections: HomeFeedResolvedSection[]
  status: 'idle' | 'loading' | 'loaded' | 'error'
}

const initialState: HomeFeedState = {
  sections: [],
  status: 'idle',
}

export const homeFeedReducer = createReducer(initialState, builder => {
  builder.addCase(setHomeFeedSections, (state, { payload }) => {
    state.sections = payload
  })
  builder.addCase(setHomeFeedStatus, (state, { payload }) => {
    state.status = payload
  })
})
